export default "__VITE_ASSET__Bi$5SRp0__"